import React, { useEffect, useState } from "react";
import "./dhenkanal360firstpage.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Dhealnavbar from "../Navbar/dhealnavbar";

import govtLogo from "../assest/sidelogo.png";
import logo from "../assest/qrcode-icon.png";
import belowimg from "../assest/footerimg.png";

const Dhenkanal360FirstPage = ({ toggleTheme, theme }) => {
  const { t } = useTranslation();   // ✅ t() use hoga
  const navigate = useNavigate();

  const [fontSize, setFontSize] = useState(100);

  const increaseFont = () => setFontSize(p => Math.min(p + 10, 150));
  const decreaseFont = () => setFontSize(p => Math.max(p - 10, 70));
  const resetFont = () => setFontSize(100);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className={`page-container theme-${theme}`}
      style={{ fontSize: fontSize + "%" }}
    >
      <Dhealnavbar
        toggleTheme={toggleTheme}
        increaseFont={increaseFont}
        decreaseFont={decreaseFont}
        resetFont={resetFont}
        hideMainNavbar={true}
      />

      {/* ===== TOP HEADER ===== */}
      <div className="top-feedbackheader">
        <div className="top-feedbackleft">
          <img src={govtLogo} alt={t("govt")} />
          <p>{t("govt")}</p>
        </div>

        <div className="top-feedbackcenter">
          <h1>{t("title_eng")}</h1>
        </div>

        <div className="top-feedbackright">
          <img src={logo} alt={t("dhenkanal360")} />
          <p>{t("dhenkanal360")}</p>
        </div>
      </div>

      {/* ===== DESCRIPTION ===== */}
      <p className="desc" style={{ whiteSpace: "pre-line" }}>
        {t("desc")}
      </p>

      {/* ===== BUTTONS ===== */}
      <div className="btn-group">
        <button
          className="feedback-btn"
          onClick={() =>
            window.open(
              "https://360.dhenkanalservice.in/office/40",
              "_blank"
            )
          }
        >
          {t("shareFeedback")}
        </button>

        <button
          className="review-btn"
          onClick={() => navigate("/officeReview")}
        >
          {t("officeReview")}
        </button>
      </div>

      <img
        src={belowimg}
        alt="bottom banner"
        className="bottom-banner-img"
      />
    </div>
  );
};

export default Dhenkanal360FirstPage;
